<dx-button-group #dx
    [items]="buttons()"
    keyExpr="key"
    stylingMode="outlined"
    [selectionMode]="selectionMode()"
    [selectedItemKeys]="computedValue()"
    (onItemClick)="onInput($event)"
>
</dx-button-group>